import { Flex, Grid, Select } from "antd";
import { CenterPopup } from "antd-mobile";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Clock from "../../assets/images/icons/Clock";
import { sessionType } from "../../enumerations/sessionType";
import { P1 } from "../NormalFonts";
import { SessionTypeSelectorProps } from "./data";
import styles from "./styles.module.scss";
import "./styles.scss";

const SessionTypeSelector: React.FC<SessionTypeSelectorProps> = ({ form }) => {
  const { t } = useTranslation();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const [openDropdown, setOpenDropdown] = useState<boolean>(false);
  const [openPopup, setOpenPopup] = useState<boolean>(false);

  const [selectedValue, setSelectedValue] = useState<
    string | number | null | undefined
  >(undefined);

  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (screens.sm) return;
    e.stopPropagation();
    setOpenPopup((prev) => !prev);
  };

  const handleDropdownVisibleChange = (visible: boolean) => {
    if (screens.sm) {
      setOpenDropdown(visible);
    } else {
      setOpenDropdown(false);
    }
  };

  const handleSessionTypeChange = (val: string | number | undefined | null) => {
    onSessionTypeChange(val);
    setSelectedValue(val);
    setOpenPopup(false);
  };

  const sessionTypeOptions = [
    {
      label: t("search.fullday"),
      value: sessionType.ALL_DAY,
    },
    {
      label: t("search.morning"),
      value: sessionType.MORNING,
    },
    {
      label: t("search.afternoon"),
      value: sessionType.AFTERNOON,
    },
  ];

  const renderSessionTypeDropdownContent = () => {
    return (
      <div className={styles.popupItem}>
        {sessionTypeOptions.map((opt, index: number) => {
          return (
            <P1
              key={`session_type_selector_${index}`}
              color="var(--Neutral-dark-70)"
              onClick={() => handleSessionTypeChange(opt.value)}
              style={{ width: "100%" }}
            >
              {opt.label}
            </P1>
          );
        })}
      </div>
    );
  };

  const onSessionTypeChange = (val: string | number | null | undefined) => {
    form.setFieldsValue({ session_type: val });
  };

  return (
    <>
      <Select
        value={
          form.getFieldValue("session_type")
            ? form.getFieldValue("session_type")
            : undefined
        }
        popupClassName="session-type-selector-popup"
        placeholder={t("home.searchbar.sessionType.hint")}
        open={openDropdown}
        onClick={handleClick}
        onDropdownVisibleChange={handleDropdownVisibleChange}
        onChange={onSessionTypeChange}
        options={sessionTypeOptions}
        dropdownRender={(menu) => <>{menu}</>}
        prefix={
          screens.lg ? null : (
            <Flex align="center">
              <Clock
                style={{
                  fontSize: 24,
                  color: "var(--Neutral-dark-80)",
                }}
              />
            </Flex>
          )
        }
        suffixIcon={
          screens.lg ? (
            <Clock
              style={{
                fontSize: 22,
                color: "var(--Neutral-dark-80)",
              }}
            />
          ) : null
        }
      />
      <CenterPopup
        getContainer={() =>
          document.getElementById("containerElement") || document.body
        }
        onClose={() => setOpenPopup(false)}
        closeOnMaskClick={true}
        visible={openPopup}
        style={{ zIndex: 10000 }}
      >
        {renderSessionTypeDropdownContent()}
      </CenterPopup>
    </>
  );
};

export default SessionTypeSelector;
